
const GOOGLE_API_KEY = "AIzaSyA2PunYGfTF_IzwkXnstj6vzSESrOnf81s" ; 

export const YOUTUBE_API_KEY = "https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&maxResults=50&chart=mostPopular&regionCode=IN&key="+ GOOGLE_API_KEY;

export const YOUTUBE_SEARCH_API = "https://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=" ;

export const OFFSET_LIVE_CHAT = 200 ; 

export const LOGO = "https://res.cloudinary.com/drdgj0pch/image/upload/v1713364610/favicoyoutube_zvnvpg.webp" ; 